import type { WalkthroughRole } from '../../content/help/walkthroughTypes';

export interface SendHelpPayload {
  role: WalkthroughRole | 'property_manager';
  recipient?: string;
  message: string;
  category?: string;
  projectId?: string;
}

export interface SendHelpResult {
  ok: boolean;
  error?: string;
}

/**
 * Submits a help/support request to the backend.
 * Uses cookie-based Clerk session auth (credentials: 'include').
 * Optionally accepts a getToken function for Bearer header injection.
 */
export const sendHelpMessage = async (
  payload: SendHelpPayload,
  getToken?: () => Promise<string | null>,
): Promise<SendHelpResult> => {
  try {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (getToken) {
      const token = await getToken().catch(() => null);
      if (token) headers['Authorization'] = `Bearer ${token}`;
    }

    const res = await fetch('/api/support/help-request', {
      method: 'POST',
      headers,
      credentials: 'include',
      body: JSON.stringify({
        message: payload.message,
        role: payload.role,
        recipient: payload.recipient,
        category: payload.category ?? 'general',
        projectId: payload.projectId,
      }),
    });

    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      return { ok: false, error: body.error ?? 'Failed to submit help request' };
    }
    return { ok: true };
  } catch (err: any) {
    console.error('[helpSendAdapter] sendHelpMessage error:', err);
    return { ok: false, error: err?.message ?? 'Network error' };
  }
};

